import React from 'react'

function ServicePageContent() {
    return(
        <div>
            <div className="container">
                <h2 className="text-primary mt-4">Our Service</h2>
                <ul>
                    <li>Solar Installation</li>
                    <li>Inverter Batteries</li>
                    <li>CCTV/CATV</li>
                    <li>Automatic Gate</li>
                    <li>Electrical control panels/ATS</li>
                    <li>Inverters Repairs</li>
                    <li>Tuya based Smart Home Automation</li>
                </ul>
            </div>



        </div>
    )
}

export default ServicePageContent